/* eslint-disable jsx-a11y/no-distracting-elements */
import "./templatesix.css";
import "../style.css";
import {
  React,
  ArrowBackIosNewIcon,
  ReactPlayer,
  useLocation,
  useNavigate,
  Marquee,
} from "../../../Libraries/Post/LayoutPreview/index";

const TemplateSix = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const handleNavigate = () => {
    if (location?.state?.from === "editpost") {
      navigate("/editPost", { state: location?.state, replace: true });
    } else if (location?.state?.from === "addnewpost") {
      navigate("/addnewpost", { state: location?.state, replace: true });
    }else{
       if(location.state.media.ser_collection_id){
          console.log("Testing");
          navigate("/groupposts", {
            state: location.state.currentScreen,
            replace: true,
          });
        }else{
          navigate("/posts", {
            state: location.state.currentScreen,
            replace: true,
          });
        }
    }
  };
  return (
    <div className="container d-flex justify-content-center align-items-center">
      <div className="tele">
        <div className="screen">
          <div className="l6page">
            <ArrowBackIosNewIcon
              id="button"
              fontSize="30px"
              style={{
                position: "absolute",
                zIndex: 10,
                fontSize: "2em",
                color: "red",
              }}
              onClick={handleNavigate}
            />
            {location.state?.finalfile.type === "Image" ? (
              <div className="main">
                <img
                  src={location.state.finalfile.link}
                  alt="img or video"
                  width="100%"
                  height="100%"
                />
              </div>
            ) : location.state?.finalfile.type === "Video" ? (
              <div className="main">
                <ReactPlayer
                  url={location.state.finalfile.link}
                  controls
                  width="100%"
                  height="100%"
                  loop={true}
                  playing={true}
                  playsInline
                />
              </div>
            ) : location.state?.finalfile?.type === "Widget" ? (
              <div className="main">
                <div
                  dangerouslySetInnerHTML={{
                    __html: location.state?.finalfile?.link,
                  }}
                  style={{ height: "100%", width: "100%" }}
                />
              </div>
            ) : null}
            <div className="sidebararea">
              <marquee direction="up" style={{ height: "100%" }}>
                {location.state?.sidebar?.map((sidebar, index) => (
                  <div key={index}>
                    <div className="row p-3 d-flex flex-column">
                      <div className="col">{sidebar.txt_sidebar_title}</div>
                      <div className="col">
                        <p>{sidebar.txt_sidebar_description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </marquee>
            </div>
            <div className="footerarea">
              <Marquee style={{ height: "100%" }} gradient={false}>
                {location.state.footer.map((footerdes, index) => (
                  <div key={index} className="mr-5">
                    {footerdes.txt_footer_description}
                  </div>
                ))}
              </Marquee>
            </div>
          </div>
        </div>
        <div className="standouter">
          <div className="stand"></div>
        </div>
      </div>
    </div>
  );
};

export default TemplateSix;
